import {PillType} from '@Components/pill/pill.types';
import type {AiContentVerificationResult} from '@Libraries/ai-content-verification.types';

export interface AiContentVerifyResultProps {
  result: AiContentVerificationResult;
  file: File;
  onCheckAnotherFile: () => void;
}

export interface AiContentVerifyResultDetail {
  labelKey: string;
  value: string;
}

export interface AiContentVerifyVerdictCopy {
  pillType: PillType;
  pillIcon: string;
  pillLabelKey: string;
  titleKey: string;
  descriptionKey: string;
}

export const AI_GENERATED_VERDICT: AiContentVerifyVerdictCopy = {
  pillType: PillType.SUCCESS,
  pillIcon: 'icon-check-circle',
  pillLabelKey: 'pmwjs_ai_verify_pill_mark_found',
  titleKey: 'pmwjs_ai_verify_result_ai_title',
  descriptionKey: 'pmwjs_ai_verify_result_ai_desc',
};

export const NO_MARKS_VERDICT: AiContentVerifyVerdictCopy = {
  pillType: PillType.NEUTRAL,
  pillIcon: 'icon-info',
  pillLabelKey: 'pmwjs_ai_verify_pill_no_mark',
  titleKey: 'pmwjs_ai_verify_result_none_title',
  descriptionKey: 'pmwjs_ai_verify_result_none_desc',
};

export const MEDIA_KIND_LABEL_KEYS: Record<string, string> = {
  image: 'pmwjs_ai_verify_kind_image',
  video: 'pmwjs_ai_verify_kind_video',
  audio: 'pmwjs_ai_verify_kind_audio',
  pdf: 'pmwjs_ai_verify_kind_pdf',
  html: 'pmwjs_ai_verify_kind_html',
};

export const DIGITAL_SOURCE_TYPE_LABEL_KEYS: Record<string, string> = {
  'http://cv.iptc.org/newscodes/digitalsourcetype/trainedAlgorithmicMedia': 'pmwjs_ai_verify_source_trained',
  'http://cv.iptc.org/newscodes/digitalsourcetype/compositeWithTrainedAlgorithmicMedia': 'pmwjs_ai_verify_source_composite_trained',
  'http://cv.iptc.org/newscodes/digitalsourcetype/algorithmicMedia': 'pmwjs_ai_verify_source_algorithmic',
  'http://cv.iptc.org/newscodes/digitalsourcetype/compositeSynthetic': 'pmwjs_ai_verify_source_composite_synthetic',
};

export const MARKED_ON_DATE_FORMAT: Intl.DateTimeFormatOptions = {dateStyle: 'medium', timeStyle: 'short'};
export const RESULT_HEADING_ID = 'ai-content-verify-result-heading';
